import api from "api/api";
import { Dispatch, SetStateAction } from "react";
import { EquipeProps } from ".";
import { Toast } from "components/toast";
import { ErrorProps, objectSchema, ObjectSchema } from "utils/object-methods";
import { fieldValidation } from "utils/field-validation";
import { openModalError } from "components/modal-error";
import { openModalConfirm } from "components/modal-confirm-new";
import { Text } from "@chakra-ui/react";

export function validateEquipe(equipe: Partial<EquipeProps>) {
  const schema: ObjectSchema<Omit<EquipeProps, "id">> = {
    customerId: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    nome: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    enabled: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    usersIds: (value) => {
      const { isValid } = fieldValidation({ value })
        .required()
        .array()
        .custom({ validate: (data) => !!data?.length });
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
  };
  return objectSchema(schema, equipe);
}

export async function handleSubmitEquipes({
  isUpdate,
  setLoading,
  equipe,
  onClose,
  setErrors,
  customerId,
}: {
  isUpdate: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  equipe: Partial<EquipeProps>;
  onClose?: () => void;
  setErrors: Dispatch<SetStateAction<ErrorProps<EquipeProps>>>;
  customerId: number;
}) {
  const { body, errors, isValid } = validateEquipe({ ...equipe, customerId });

  if (!isValid) {
    setErrors(errors);
    console.log("ERRORS =>", errors);
    return;
  }

  setLoading(true);
  try {
    if (isUpdate) {
      await api.put(`/equipes/${equipe.id}`, {
        ...body,
        customerId: undefined,
      });
    } else await api.post(`/equipes`, body);
    onClose?.();
  } catch (e: any) {
    const errorType = e?.response?.data?.message;
    if (errorType === "equipe_associada_sessao") {
      openModalConfirm({
        message: (
          <Text>
            <b>Equipe está associada a uma sessão.</b> Deseja{" "}
            <Text as="span" color="red.600">
              remover a associação
            </Text>{" "}
            e{" "}
            <Text as="span" color="red.600">
              inativar
            </Text>{" "}
            a equipe?
          </Text>
        ),
        onConfirm: async () => {
          try {
            await api.put(
              `/equipes/${equipe.id}`,
              { ...body, customerId: undefined },
              { params: { force: true } }
            );
            onClose?.();
          } catch (e) {
            Toast({ title: "Erro ao salvar equipe." });
          }
        },
      });
    } else Toast({ title: "Erro ao salvar equipe." });
    //
  } finally {
    setLoading(false);
  }
}
